module.exports = __webpack_public_path__ + "static/media/nodejs.a83f1a12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/nodejs.jpg
// module id = 99
// module chunks = 0